// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ForkOutlinedSvg from "@ant-design/icons-svg/es/asn/ForkOutlined";
import AntdIcon from '../components/AntdIcon';

var ForkOutlined = function ForkOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ForkOutlinedSvg
  }));
};

ForkOutlined.displayName = 'ForkOutlined';
export default React.forwardRef(ForkOutlined);